import { call, select } from 'redux-saga/effects'
import {getUserIdentity} from "state/app/selectors";
import {forceRegistration} from "lib/native";

export default function* forceRegistrationSaga(action) {
  const userIdentity = yield select(getUserIdentity);
  // user is being kicked here, so we need to clear any local storage we had
  // In future, the native client should clear the local storage/cache here,
  // but for now we can do it manually
  localStorage.clear();
  return yield call(forceRegistration, userIdentity.get("platform"), action.payload.userMessage);
}



// WEBPACK FOOTER //
// ./src/state/app/sagas/forceRegistration.js